// Mock data for Axicle Robotics website

export const heroData = {
  headline: "Modern Trucks. Outdated Coupling. We're Closing the Gap.",
  subheadline: "Automated. Safe. Efficient.",
  description: "Axicle's Robotic Coupling System revolutionizes trucking operations with automatic trailer coupling in 30 seconds, preventing rollovers and saving $17,500 per truck annually.",
  ctaText: "Get in Touch",
  secondaryCtaText: "Watch Demo"
};

export const featuresData = [
  {
    id: 1,
    title: "Automated Coupling",
    description: "Connect truck to trailer automatically in 30 seconds without drivers leaving the cab. No manual labor required.",
    icon: "Zap",
    stats: "30 seconds coupling time"
  },
  {
    id: 2,
    title: "Rollover Prevention",
    description: "Advanced safety system prevents truck rollovers, protecting drivers and cargo with intelligent stability control.",
    icon: "Shield",
    stats: "175 lives saved annually"
  },
  {
    id: 3,
    title: "Fuel Efficiency",
    description: "Close the gap between truck and trailer at high speeds, reducing drag and saving up to 5% in fuel costs.",
    icon: "Fuel",
    stats: "3,000 gallons saved per year"
  }
];

export const benefitsData = {
  headline: "Transforming Trucking Economics",
  annualSavings: "$17,500",
  savingsBreakdown: [
    { category: "Time Savings", amount: "$7,500", description: "Save 150+ hours per driver annually" },
    { category: "Safety Savings", amount: "$7,000", description: "Reduce accidents and liability costs" },
    { category: "Fuel Savings", amount: "$3,000", description: "5% improvement in fuel efficiency" }
  ],
  industryImpact: ">$120 Billion",
  impactDescription: "Annual cost of inefficiency in trucking industry"
};

export const targetAudienceData = [
  {
    id: 1,
    title: "For OEMs",
    description: "Seamless integration with new truck models. Drop-in replacement for standard fifth wheels.",
    benefits: [
      "Easy integration into manufacturing",
      "Enhanced vehicle value proposition",
      "Competitive advantage in market",
      "Future-ready for autonomous fleets"
    ],
    cta: "Partner With Us"
  },
  {
    id: 2,
    title: "For Fleet Operators",
    description: "Retrofit your existing fleet and start saving immediately. Proven ROI in months, not years.",
    benefits: [
      "Immediate operational savings",
      "Improved driver satisfaction",
      "Reduced insurance costs",
      "Enhanced fleet safety record"
    ],
    cta: "Request Quote"
  }
];

export const credibilityData = {
  headline: "Validated Technology, Proven Results",
  credentials: [
    {
      id: 1,
      title: "Virginia Tech Study",
      description: "Independent scientific validation confirms safety and efficiency improvements",
      icon: "GraduationCap"
    },
    {
      id: 2,
      title: "Patent Portfolio",
      description: "Strong intellectual property protection with comprehensive patent coverage",
      icon: "FileCheck"
    },
    {
      id: 3,
      title: "Industry Partnerships",
      description: "Joint validation with leading truck manufacturers and fleet operators",
      icon: "Handshake"
    }
  ],
  stats: [
    { value: "150+", label: "Hours Saved Per Driver/Year" },
    { value: "30 sec", label: "Coupling Time" },
    { value: "5%", label: "Fuel Efficiency Gain" },
    { value: "$17.5k", label: "Annual Savings Per Truck" }
  ]
};

export const videoData = {
  headline: "See the Robotic Coupling System in Action",
  description: "Watch how our system transforms the trailer coupling process from a dangerous, time-consuming task into a seamless 30-second operation.",
  videoPlaceholder: true,
  thumbnailText: "Demo Video Coming Soon"
};

export const contactFormData = {
  headline: "Ready to Transform Your Fleet?",
  description: "Whether you're a fleet operator, OEM, or potential partner, we'd love to hear from you.",
  formFields: [
    { name: "fullName", label: "Full Name", type: "text", required: true },
    { name: "email", label: "Email", type: "email", required: true },
    { name: "company", label: "Company", type: "text", required: true },
    { name: "phone", label: "Phone Number", type: "tel", required: false },
    { name: "userType", label: "I am a", type: "select", required: true, options: ["Customer", "Investor"] },
    { name: "message", label: "Message", type: "textarea", required: true }
  ],
  submitText: "Send Message",
  successMessage: "Thank you for your interest! We'll be in touch shortly."
};

export const footerData = {
  company: "Axicle Robotics",
  tagline: "Revolutionizing trucking through automation",
  copyright: "© 2024 Axicle Robotics. All rights reserved.",
  links: [
    { label: "Product", href: "#features" },
    { label: "Benefits", href: "#benefits" },
    { label: "Contact", href: "#contact" }
  ]
};
